export const convertToDate = (value: string | number): Date => {
  const valueNumber: number = typeof value === "number" ? value : parseInt(value);
  return new Date(valueNumber);
};
